import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthActions } from '@fantaz/shared/auth';
import { TermsAndConditionsService } from '@fantaz/shared/data-access/api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';
import { TermsAndConditionsStore } from '../../store';

@Injectable()
export class TermsAndConditionsEffect {
  verifyTermsAndConditions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActions.loadUserSuccess),
        tap(() => {
          // check if user has accepted latest terms and conditions
          return this.termsAndConditionsStore.init();
        }),
      ),
    { dispatch: false },
  );

  constructor(
    private actions$: Actions,
    private termsAndConditionsStore: TermsAndConditionsStore,
    private readonly termsAndConditionsService: TermsAndConditionsService,
    private readonly dialog: MatDialog,
  ) {}
}
